import React from 'react';
import IncubatorCycleTable from '../../AppGrid/IncubatorCycleTable';

const IncubatorCycleList = ({searchParam}) => (
			<IncubatorCycleTable searchParams={searchParam} />
		);
export default IncubatorCycleList